<div class="answering-rule-container">
  @let brandingData = (brandingService.brandingData$ | async) || defaultBrandingSettings;
  <div class="content">
    <mat-icon class="drag-indicator"> drag_indicator </mat-icon>
    <div class="time-frame-label">
      {{ answeringRule.timeFrame === '*' ? ('ANSWERING_RULES_PREFERENCES.DEFAULT' | translate) : answeringRule.timeFrame }}
    </div>
    @let activeRule = answeringRuleService.activeRuleName$ | async;
    @if (
      answeringRule.enabled &&
      (activeRule === answeringRule.timeFrame || (activeRule === 'Default' && answeringRule.timeFrame === '*'))
    ) {
      <div class="active-label">{{ 'ANSWERING_RULES_PREFERENCES.ACTIVE' | translate }}</div>
    }
    <div class="time-frame-info">
      {{ ruleTypeString }}
      @if (answeringRule.forwardAlways.enabled) {
        <div>
          {{ answeringRule.forwardAlways.destination }}
        </div>
      }
    </div>
    <div
      class="buttons"
      [ngClass]="{ disabled: disabled, editable: editable }">
      <mat-icon
        (click)="editRule()"
        appBrandingColor
        [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
        styleType="color">
        edit_outline
      </mat-icon>
      @if (answeringRule.timeFrame !== '*' && appConfigService.features[AppFeature.ModifyAnsweringRules]) {
        <mat-icon
          (click)="deleteRule()"
          appBrandingColor
          [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
          styleType="color">
          delete_outline
        </mat-icon>
      }
    </div>
    <mat-slide-toggle
      [checked]="answeringRule.enabled"
      [disabled]="disabled"
      (change)="stateChanged($event)"
      [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]">
    </mat-slide-toggle>
  </div>
</div>
